export const SUPPORTED_UI_LANGUAGES = new Set(["en", "ru", "sk", "cs"]);
export const UI_LANGUAGE_STORAGE_KEY = "vg_ui_language";
export const UI_LANGUAGE_SOURCE_STORAGE_KEY = "vg_ui_language_source_v1";
export const UI_LANGUAGE_SOURCE_DEVICE = "device";
export const UI_LANGUAGE_SOURCE_MANUAL = "manual";

export function normalizeUiLanguage(value) {
  const language = String(value || "")
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
  return SUPPORTED_UI_LANGUAGES.has(language) ? language : "en";
}

export function normalizeContourUiLanguage(value, region) {
  if (String(region || "").trim().toUpperCase() === "RU") return "ru";
  const language = normalizeUiLanguage(value);
  return language === "sk" || language === "cs" ? language : "en";
}

export function getPreferredDeviceLanguage(navigatorLike) {
  const source = navigatorLike
    || (typeof navigator !== "undefined" ? navigator : null);
  const primaryLanguage = Array.isArray(source?.languages) && source.languages.length
    ? source.languages[0]
    : source?.language;
  return normalizeUiLanguage(primaryLanguage);
}

export function initializeNativeUiLanguagePreference(
  storageLike,
  navigatorLike
) {
  const storage = storageLike
    || (typeof localStorage !== "undefined" ? localStorage : null);
  const deviceLanguage = getPreferredDeviceLanguage(navigatorLike);

  try {
    const source = storage?.getItem?.(UI_LANGUAGE_SOURCE_STORAGE_KEY);
    const storedLanguage = storage?.getItem?.(UI_LANGUAGE_STORAGE_KEY);
    if (source === UI_LANGUAGE_SOURCE_MANUAL && storedLanguage) {
      return normalizeUiLanguage(storedLanguage);
    }

    // Existing installs may contain an IP/profile-derived language without a
    // source marker. Migrate that stale value to the current phone language.
    storage?.setItem?.(UI_LANGUAGE_STORAGE_KEY, deviceLanguage);
    storage?.setItem?.(UI_LANGUAGE_SOURCE_STORAGE_KEY, UI_LANGUAGE_SOURCE_DEVICE);
  } catch {
    // The in-memory device language remains usable when WebView storage fails.
  }
  return deviceLanguage;
}
